import React, { Component } from "react";
import {
  profile,
  GET,
  PUT,
  alert,
  loading,
  tokens,
  locale,
  Modal,
  required,
  float,
} from "./CustomComponent.js";
import { Navbar, Nav } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import LOGO from "../assets/images/logo.png";
import US from "../assets/images/us.png";
import TH from "../assets/images/th.png";
import JP from "../assets/images/jp.png";
import CH from "../assets/images/ch.png";
import "../assets/css/bootstrap.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_quotation: false,

      data_product: [],

      product: [],
      full_name: "",
      email: "",
      phone: "",
      message: "",
    };
  }
  componentDidMount = async () => {
    this.translatePage();
    loading(false);
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let result = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== result.last_update)
    ) {
      this.Get();
    } else {
      this.setState({
        data_product: tokens?.product ? Object.values(tokens?.product) : [],
      });
    }
  };
  //    componentDidUpdate() {
  //     this.translatePage();
  // }
  translatePage() {
    if (!locale || !global.i18[locale]) return;

    const dict = global.i18[locale];
    const ignoreTags = ["SCRIPT", "STYLE"];

    function replaceText(str) {
      if (!str) return str;
      let s = str;
      Object.keys(dict).forEach((key) => {
        if (!dict[key]) return;
        const regex = new RegExp(
          key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
          "gi"
        );
        s = s.replace(regex, dict[key]);
      });
      return s;
    }

    function walk(node) {
      if (!node || ignoreTags.includes(node.nodeName)) return;

      // translate attributes (skip value for input/textarea)
      if (node.attributes) {
        [...node.attributes].forEach((attr) => {
          if (attr.name === "href") return; // ⛔ ไม่แปล URL
          if (
            attr.name === "value" &&
            (node.nodeName === "INPUT" || node.nodeName === "TEXTAREA")
          )
            return;

          const newVal = replaceText(attr.value);
          if (newVal !== attr.value) attr.value = newVal;
        });
      }

      // text node
      if (node.nodeType === 3) {
        const newText = replaceText(node.nodeValue);
        if (newText !== node.nodeValue) node.nodeValue = newText;
      }

      // children
      node.childNodes?.forEach(walk);
    }

    // initial translate
    walk(document.body);

    // 👇 FIX: translate new DOM (dropdown, modal, dynamic)
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes?.forEach((node) => walk(node));
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  Get = async () => {
    loading(true);
    let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
    let result = await response.json();
    localStorage.setItem("scp-acc-tk", JSON.stringify(result));
    this.setState({
      data_product: result?.product ? Object.values(result?.product) : [],
    });
    loading(false);
  };
  Submit = async () => {
    const { product, full_name, email, phone, message } = this.state;
    if (!full_name) {
      alert("", "warning", "แจ้งเตือน", "กรุณาชื่อ-นามสกุล");
      return;
    }
    if (!email) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    }
    if (!email.includes("@")) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง");
      return;
    }
    if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    }
    if (phone.length < 10) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ครบถ้วน");
      return;
    }
    if (!float(phone)) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ถูกต้อง");
      return;
    }
    loading(true);

    await fetch(
      process.env.REACT_APP_API_URL + `/contact/${new Date().getTime()}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: new Date().getTime(),
          product,
          full_name,
          email,
          phone,
          message,
        }),
      }
    );
    loading(false);
    alert(
      "#",
      "success",
      "สำเร็จ",
      "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด"
    );
  };

  icon = (io) => <span className="icon">{io}</span>;

  componentMenu = () => {
    return (
      <>
        <div className="py-2">
          <a
            className={
              window.location.pathname === "/"
                ? "btn-custom mx-1 active"
                : "btn-custom mx-1"
            }
            href="/"
          >
            หน้าแรก
          </a>
        </div>
        <div className="py-2">
          <a
            className={
              window.location.pathname === "/about"
                ? "btn-custom mx-1 active"
                : "btn-custom mx-1"
            }
            href="/about"
          >
            เกี่ยวกับเรา
          </a>
        </div>
        <div className="py-2">
          <a
            className={
              window.location.pathname === "/product"
                ? "btn-custom mx-1 active"
                : "btn-custom mx-1"
            }
            href="/product"
          >
            สินค้าของเรา
          </a>
        </div>
        <div className="py-2">
          <a
            className={
              window.location.pathname === "/standards-and-research"
                ? "btn-custom mx-1 active"
                : "btn-custom mx-1"
            }
            href="/standards-and-research"
          >
            มาตรฐานและงานวิจัย
          </a>
        </div>
        <div className="py-2">
          <a
            className={
              window.location.pathname === "/contact"
                ? "btn btn-primary mx-1 active"
                : "btn btn-primary mx-1"
            }
            href="/contact"
          >
            ติดต่อเรา
          </a>
        </div>
        {/* <div className="d-flex justify-content-start">
          <button
            className="btn btn-link px-1"
            onClick={() => {
              localStorage.setItem("locale", "us");
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }}
          >
            <img
              alt="LOGO"
              src={US}
              width={16}
              style={{ objectFit: "contain" }}
            />
          </button>
          <button
            className="btn btn-link px-1"
            onClick={() => {
              localStorage.setItem("locale", "");
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }}
          >
            <img
              alt="LOGO"
              src={TH}
              width={16}
              style={{ objectFit: "contain" }}
            />
          </button>
          <button
            className="btn btn-link px-1"
            onClick={() => {
              localStorage.setItem("locale", "jp");
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }}
          >
            <img
              alt="LOGO"
              src={JP}
              width={16}
              style={{ objectFit: "contain" }}
            />
          </button>
          <button
            className="btn btn-link px-1"
            onClick={() => {
              localStorage.setItem("locale", "cn");
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }}
          >
            <img
              alt="LOGO"
              src={CH}
              width={16}
              style={{ objectFit: "contain" }}
            />
          </button>
        </div> */}
      </>
    );
  };

  render() {
    const {
      modal_quotation,
      data_product,
      full_name,
      email,
      phone,
      message,
    } = this.state;
    return (
      <div>
      <div className="w-100 position-fixed" style={{ zIndex: 1000 }}>
        <div className="border-bottom bg-light" style={{ zIndex: 1001 }}>
          <div className="container d-flex align-items-center justify-content-between">
            <div className="d-flex">
              <span className="me-3"><span className="icon me-2 text-14">{"\uf0e0"}</span></span>
              <span className="me-3"><span className="icon me-2 text-12">{"\uf095"}</span></span>
            </div>
            <div>
              <Dropdown style={{ zIndex: 1001 }}>
                <Dropdown.Toggle
                  variant="light"
                  id="dropdown-basic"
                  size="sm"
                  className={
                    window.location.pathname === "/customer"
                      ? "btn-custom mx-1 active"
                      : "btn-custom mx-1"
                  }
                >
                  <img
                    alt="LOGO"
                    src={
                      locale === "us"
                        ? US
                        : locale === "jp"
                        ? JP
                        : locale === "cn"
                        ? CH
                        : TH
                    }
                    width={16}
                    style={{ objectFit: "contain" }}
                    className="me-2"
                  />
                  {locale === "us"
                    ? "EN"
                    : locale === "jp"
                    ? "JA"
                    : locale === "cn"
                    ? "CN"
                    : "TH"}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow py-0 overflow-hidden">
                  <Dropdown.Item
                    onClick={() => {
                      localStorage.setItem("locale", "us");
                      setTimeout(() => {
                        window.location.reload();
                      }, 100);
                    }}
                    className="border-bottom"
                  >
                    <img
                      alt="LOGO"
                      src={US}
                      width={16}
                      style={{ objectFit: "contain" }}
                      className="me-2"
                    />{" "}
                    อังกฤษ
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      localStorage.setItem("locale", "");
                      setTimeout(() => {
                        window.location.reload();
                      }, 100);
                    }}
                    className="border-bottom"
                  >
                    <img
                      alt="LOGO"
                      src={TH}
                      width={16}
                      style={{ objectFit: "contain" }}
                      className="me-2"
                    />{" "}
                    ไทย
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      localStorage.setItem("locale", "jp");
                      setTimeout(() => {
                        window.location.reload();
                      }, 100);
                    }}
                    className="border-bottom"
                  >
                    <img
                      alt="LOGO"
                      src={JP}
                      width={16}
                      style={{ objectFit: "contain" }}
                      className="me-2"
                    />{" "}
                    ญี่ปุ่น
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      localStorage.setItem("locale", "cn");
                      setTimeout(() => {
                        window.location.reload();
                      }, 100);
                    }}
                    className="border-bottom"
                  >
                    <img
                      alt="LOGO"
                      src={CH}
                      width={16}
                      style={{ objectFit: "contain" }}
                      className="me-2"
                    />{" "}
                    จีน
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
        <Navbar
          className="py-1 bg-light w-100"
          style={{ zIndex: 1000 }}
          expand="xl"
        >
          <div className="container px-3 px-xl-4">
            <Navbar.Brand href="/" className="fw-bold text-dark">
              <div className="position-relative">
                <img
                  alt="logo"
                  src={LOGO}
                  height={50}
                  style={{ objectFit: "contain" }}
                  className="pointer"
                  onClick={() => {
                    window.location.href = "/";
                  }}
                />
              </div>
            </Navbar.Brand>
            <Navbar.Toggle
              className="border-0"
              aria-controls="basic-navbar-nav"
            />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto py-0">
                <div className="d-none d-xl-flex align-items-center px-3">
                  {this.componentMenu()}
                </div>
                <div
                  className="d-block d-xl-none mb-5 pt-4"
                  style={{ height: "80vh" }}
                >
                  {this.componentMenu()}
                </div>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>

        <Modal
          show={modal_quotation}
          onHide={() => this.setState({ modal_quotation: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <div>
              <h4 className="fw-bold mb-0">ขอใบเสนอราคา</h4>
              <small>ต้องกรอกฟิลด์ที่มีเครื่องหมาย {required}</small>
            </div>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="row">
              <div className="col-12 mb-2">
                <div className="mb-2">
                  เลือกรุ่นที่ต้องการใบเสนอราคา {required}
                </div>
                {data_product.map((item, index) => (
                  <div key={index}>
                    <input
                      type="checkbox"
                      name="product"
                      value={item.th_product_name}
                      checked={this.state.product.includes(item.product_name)}
                      onChange={(e) => {
                        const { product } = this.state;
                        if (e.target.checked) {
                          this.setState({
                            product: [...product, item.product_name],
                          });
                        } else {
                          this.setState({
                            product: product.filter(
                              (p) => p !== item.product_name
                            ),
                          });
                        }
                      }}
                    />{" "}
                    {item[`${locale}_product_name`] || item.th_product_name}
                  </div>
                ))}
              </div>
              <div className="col-12 mb-2">
                <div className="mb-2">ชื่อ - นามสกุล {required}</div>
                <input
                  className="form-control mb-3"
                  type="text"
                  placeholder="ชื่อ - นามสกุล"
                  onChange={(e) => {
                    this.setState({ full_name: e.target.value });
                  }}
                  value={full_name}
                />
              </div>
              <div className="col-12 mb-2">
                <div className="mb-2">อีเมล {required}</div>
                <input
                  className="form-control mb-3"
                  type="email"
                  placeholder="อีเมล"
                  onChange={(e) => {
                    this.setState({ email: e.target.value });
                  }}
                  value={email}
                />
              </div>
              <div className="col-12 mb-2">
                <div className="mb-2">เบอร์โทรศัพท์</div>
                <input
                  className="form-control mb-3"
                  type="text"
                  placeholder="เบอร์โทรศัพท์"
                  maxLength={10}
                  onChange={(e) => {
                    if (!float(e.target.value)) {
                      return;
                    }
                    this.setState({ phone: e.target.value });
                  }}
                  value={phone}
                />
              </div>
              <div className="col-12 mb-2">
                <div className="mb-2">คำถามหรือความคิดเห็น</div>
                <textarea
                  className="form-control mb-3"
                  rows={8}
                  placeholder="คำถามหรือความคิดเห็น"
                  onChange={(e) => {
                    this.setState({ message: e.target.value });
                  }}
                  value={message}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <button
              className="btn btn-danger px-5 w-100"
              onClick={async () => {
                this.Submit();
              }}
            >
              ขอใบเสนอราคา
            </button>
          </Modal.Footer>
        </Modal>
      </div>
      <div className="hpx-100"/>
      </div>
    );
  }
}
